var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 14,
    viewBox: "0 0 17 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.7297 0.0625H4.06719C3.02787 0.0625 2.03112 0.437834 1.29621 1.10593C0.561305 1.77403 0.148438 2.68017 0.148438 3.625V10.375C0.148437 10.8428 0.249799 11.3061 0.446735 11.7383C0.64367 12.1705 0.932323 12.5633 1.29621 12.8941C2.03112 13.5622 3.02787 13.9375 4.06719 13.9375H12.7297C13.7683 13.9355 14.7638 13.5595 15.4983 12.8919C16.2327 12.2242 16.6463 11.3192 16.6484 10.375V3.625C16.6463 2.68078 16.2327 1.77579 15.4983 1.10812C14.7638 0.440452 13.7683 0.0644816 12.7297 0.0625ZM9.71844 6.3025C9.31254 6.51294 8.85333 6.62361 8.38606 6.62361C7.91879 6.62361 7.45959 6.51294 7.05369 6.3025L1.40244 3.355C1.47551 2.75898 1.78772 2.20836 2.27934 1.80847C2.77097 1.40859 3.4075 1.1875 4.06719 1.1875H12.7297C13.3889 1.18914 14.0244 1.4108 14.5157 1.81038C15.0069 2.20995 15.3196 2.75962 15.3944 3.355L9.71844 6.3025Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/email.c8d340aa1a9dc3e7fd8dbdf193c61065.svg";
export { ForwardRef as ReactComponent };